import { VisitNodePassage } from "../../types";
export const addReferenceDateVisitor = () => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    if (args.visitable.data) {
        args.visitable.data.forEach((da) => {
            if (da.measures && !da.measures.ReferenceDate) {
                da.measures.ReferenceDate = da.date;
            }
        });
    }
    else if (args.visitable.measures && !args.visitable.measures.ReferenceDate) {
        args.visitable.measures.ReferenceDate = args.visitable.date;
    }
};
